import { Settings } from 'lucide-react';

import { defineArea } from '../../app/area';
import { SettingsPage } from './SettingsPage';

/**
 * OWNER: web shell.
 *
 * Account-level settings only (profile, language, session). SYSTEM settings —
 * the `app_settings` table, printer registry, permission matrix — belong to the
 * modules that own them and should register their own routes under
 * `/settings/<thing>` from their own area file.
 */
export default defineArea({
  id: 'settings',
  nav: [
    {
      section: 'system',
      to: '/settings',
      labelKey: 'common:nav.admin.settings',
      icon: Settings,
      order: 20,
      end: true,
    },
  ],
  routes: [{ path: 'settings', element: <SettingsPage /> }],
});
